<button
  mat-stroked-button
  (click)="onClick()"
  [disabled]="disabled || inProgress"
  [className]="
    (color == 'blue')
      ?
      (disabled || inProgress)
        ? 'mat-stroked-button confirm-button confirm-button-disabled'
        : 'mat-stroked-button confirm-button'
      :
      (disabled || inProgress)
        ? 'mat-stroked-button cancel-button cancel-button-disabled'
        : 'mat-stroked-button cancel-button'
  "
>
  <span *ngIf="!inProgress">{{ buttonText }}</span>
  <div *ngIf="inProgress" class="spinner-wrapper">
    <span>{{ inProgressText }}</span>
    <mat-spinner color="primary" [diameter]="16"></mat-spinner>
  </div>
</button>
